import styled, { css } from 'styled-components'

export type RadioButtonProps = {
  checked: boolean
}

export const RadioButton = styled.div<RadioButtonProps>`
  ${({ checked }) => css`
    border: ${checked
      ? '2px solid #0D71F0'
      : '2px solid rgba(160, 164, 179, 1)'};
    background-color: ${checked ? '#0D71F0' : '#FFFFFF'};

    &:before {
      transform: ${checked ? 'scale(1)' : 'scale(0)'};
    }
  `}

  cursor: pointer;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;

  &:before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
    background-color: #fff;
    border-radius: 50%;
    transition: all 0.3s;
  }
`
